import React from 'react';

const RocketIcon = ({ size = 32, className = '' }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="#f8fafc"
      d="M16 1 L24 15 L19 15 L21 30 L16 25 L11 30 L13 15 L8 15 Z"
    />
    <path className="rocket-flame" fill="#ff6b35" d="M13 24 Q16 31 19 24 L16 27 Z" />
    <path className="rocket-flame-inner" fill="#fbbf24" d="M14 26 Q16 30 18 26 Z" />
    <circle fill="#ef4444" cx="16" cy="9" r="2.5" />
    <rect fill="#94a3b8" x="14" y="14" width="4" height="3" rx="0.5" />
  </svg>
);

export default RocketIcon;
